<template>
  <section class="faq-footer py-10">
    <v-container>
      <v-row>
        <!-- Texto à esquerda -->
        <v-col cols="12" md="5" class="text-secondary">
          <h2 class="text-h4 font-weight-bold mb-4">Dúvidas Frequentes</h2>
          <p class="text-subtitle-1 mb-6">
            Ficou com alguma dúvida? Confira nossa lista das perguntas mais
            frequentes.
          </p>
          <v-btn
            color="secondary"
            text
            tag="router-link"
            :to="{ path: '/faq' }"
          >
            Saber mais
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>

        <!-- Accordion à direita -->
        <v-col cols="12" md="7">
          <v-expansion-panels multiple elevation="1" class="faq-panels">
            <v-expansion-panel v-for="(item, index) in faq" :key="index">
              <v-expansion-panel-title>{{
                item.question
              }}</v-expansion-panel-title>
              <v-expansion-panel-text>{{ item.answer }}</v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "FaqFooter",
  data() {
    return {
      faq: [
        {
          question: "O que é a nossa plataforma?",
          answer:
            "É um ecossistema onde makers, designers e lojistas se conectam para criar, vender e imprimir modelos 3D.",
        },
        {
          question: "Preciso ter impressora 3D para participar?",
          answer:
            "Não! Você pode apenas comprar, vender modelos ou contratar serviços de impressão.",
        },
        {
          question: "Como funciona o sistema de cotação?",
          answer:
            "Basta enviar o modelo e receber orçamentos automáticos com base nos materiais e peso estimado.",
        },
        {
          question: "Posso vender meus próprios modelos?",
          answer:
            "Sim! Cadastre-se como designer e envie seus arquivos diretamente pela plataforma.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.faq-panels {
  border-radius: 8px;
  overflow: hidden;
}

.faq-panels .v-expansion-panel-title {
  font-weight: 500;
  font-size: 1rem;
}

.faq-panels .v-expansion-panel-text {
  font-size: 0.95rem;
}
</style>
